import React from 'react'

const CallMadeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={'green'}
    width="40"
    height="40"
    viewBox="0 0 24 24"
  >
    <title>Call placed</title>
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z" />
  </svg>
  )

export default CallMadeIcon




// WEBPACK FOOTER //
// ./src/components/assets/CallMadeIcon.js